<template>
    <div id="app">
        <yetkidialog ref="yetkidialog"></yetkidialog>
        <onaydialog ref="onaydialog"></onaydialog>
        <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
        <loadingcomp v-bind:mesaj="loadingmesaj" v-model="loadingvmodel"></loadingcomp>

        <!-- toolbar -->
        <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
                <v-toolbar-title>{{ $t("Transfer-List") }}</v-toolbar-title>
                <v-spacer></v-spacer>

                <v-flex xs12 sm3 md3>
                    <v-text-field flat="" prepend-inner-icon="live_help" v-model="Rapor.Filtreler.SearchText"
                        solo-inverted="" hide-details :label="$t('Search')" @click:append="getListPageZero()"
                        append-icon="search" @keyup.enter="getListPageZero()">
                    </v-text-field>
                </v-flex>
            </v-toolbar>
        </v-flex>

        <!-- form input -->
        <v-flex xs12 sm12 md12>
            <v-form ref="formFilters" lazy-validation>
                <v-card flat class="pa-3">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-layout row wrap>
                                <!-- Kayıt Tarihi Başlangıcı -->
                                <v-flex xs12 sm6 md2>
                                    <tarihim :etiket="$t('Starting-Date')" v-model="Rapor.Filtreler.KayitTarihiBasla"
                                        :detaygizle="false" :rules="[(v) => !!v || $t('Please-select-a-date')]"
                                        v-bind:defaultvalue="'ok'"></tarihim>
                                </v-flex>

                                <!-- Kayıt Tarihi Bitişi -->
                                <v-flex xs12 sm6 md2>
                                    <tarihim :etiket="$t('Finishing-Date')" v-model="Rapor.Filtreler.KayitTarihiBitis"
                                        :detaygizle="false" :rules="[(v) => !!v || $t('Please-select-a-date')]"
                                        v-bind:defaultvalue="'ok'"></tarihim>
                                </v-flex>

                                <!-- Para Birimi -->
                                <v-flex xs12 sm6 md2>
                                    <v-select hide-details v-model="Rapor.Filtreler.ParaBirimi" :items="dovizItems"
                                        :rules="[(v) => !!v || $t('Mandatory-section')]" item-text="Title"
                                        item-value="DovizKod" :label="$t('Currency-Unit')"></v-select>
                                </v-flex>

                                <!-- Arama Buttons -->
                                <v-flex xs12 sm6 md2>
                                    <v-layout>
                                        <v-btn color="info" @click="getList()" fab small dark>
                                            <v-icon>search</v-icon>
                                        </v-btn>
                                        <v-badge color="white" :overlap="true">
                                            <template v-slot:badge>
                                                <v-icon v-if="filtrevarmi" large
                                                    color="green">check_circle_outline</v-icon>
                                            </template>
                                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false"
                                                ref="fab" @click="filtreOpen()" color="info" fab dark>
                                                <v-icon>filter_list</v-icon>
                                            </v-btn>
                                        </v-badge>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card>
            </v-form>
        </v-flex>

        <!-- Sıralama ve Sayfa Seçimi -->
        <v-flex xs12 sm12 md12 pl-3 pr-3>
            <v-card width="100%" flat color="grey lighten-5">
                <v-layout row wrap align-center>
                    <v-flex xs12 sm12 md9 class="headline font-weight-regular pl-3 grey--text">
                        {{ totalCountText }}
                    </v-flex>
                    <v-flex xs12 sm12 md2 pt-2>
                        <v-select :label="$t('Sort-By')" :items="siralamaItems" item-text="Text" item-value="Value"
                            v-model="Rapor.Paging.SiralamaTip" @change="getListPageZero()"></v-select>
                    </v-flex>
                    <v-flex xs12 sm12 md1 pt-2>
                        <v-select :label="$t('Show')" :items="veriItem" item-text="Text" item-value="Value"
                            v-model="Rapor.Paging.VeriAdet" @change="getListPageZero()"></v-select>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-flex>

        <!-- listeleme -->
        <v-container fluid grid-list-sm>
            <v-flex v-for="item in cardItems" v-bind:key="item.SiraNo" pb-3 xs12 sm12 md12>
                <v-hover>
                    <v-card width="100%" slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 2}`"
                        class="elevation-1 pt-3 pl-3 pb-3">
                        <v-layout row wrap align-center justify-end>
                            <!-- PNR ve Detaylar -->
                            <v-flex xs12 sm6 md3>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                        <v-icon color="info" small>confirmation_number</v-icon>
                                        {{ item.PNR_No }}
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                        <v-icon color="info" small>confirmation_number</v-icon>
                                        {{ item.RezzKod }}
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                        <v-icon color="#67768f" small>supervisor_account</v-icon>
                                        {{ item.Isim }}
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="font-weight-bold grey--text caption">
                                        <v-icon color="#67768f" small>payment</v-icon>
                                        {{ item.CariKod }} / {{ item.Unvan }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <!-- Tarihler -->
                            <v-flex xs12 sm6 md2>
                                <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                    <span style="color: #67768f">{{ $t('Record') }}:</span>
                                    {{ item.KayitTarihi | dateformat }}
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                    <span style="color: #67768f">{{ $t('Pickup') }}:</span>
                                    {{ item.IlkGiris | dateformat }}
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                    <span style="color: #67768f">{{ $t('Dropoff') }}:</span>
                                    {{ item.SonCikis | dateformat }}
                                </v-flex>
                            </v-flex>

                            <!-- Transfer Sağlayıcısı -->
                            <v-flex xs12 sm6 md2>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12 class="font-weight-large grey--text caption">
                                        <v-icon color="info" small>directions_car</v-icon>
                                        {{ item.SaticiAd }}
                                    </v-flex>
                                    <v-flex xs12 sm12 md12 class="font-weight-medium grey--text caption">
                                        <span style="color: #67768f">{{ $t('Tour-Operator') }}:</span>
                                        {{ item.TurOperator || '-' }}
                                    </v-flex>
                                </v-layout>
                            </v-flex>

                            <!-- Finansal Bilgiler -->
                            <v-flex xs12 sm6 md2>
                                <v-flex xs12 sm12 md12 class="font-weight-large grey--text caption">
                                    <span style="color: #67768f">{{ $t('Purchase-Total') }}:</span>
                                    {{ item.Alis | moneyformat }} {{ selectedCurrency }}
                                </v-flex>
                                <v-flex xs12 sm12 md12 class="font-weight-large grey--text caption">
                                    <span style="color: #67768f">{{ $t('Received-Coms.-Total') }}:</span>
                                    {{ item.Komisyon | moneyformat }} {{ selectedCurrency }}
                                </v-flex>
                            </v-flex>

                            <!-- Satış Toplamı -->
                            <v-flex xs12 sm6 md2>
                                <v-flex xs12 sm12 md12 style="color: #67768f"
                                    class="font-weight-regular headline text-md-center">
                                    {{ item.Satis | moneyformat }} {{ selectedCurrency }}
                                </v-flex>
                            </v-flex>

                            <!-- İşlemler -->
                            <v-flex xs12 sm6 md1>
                                <v-layout row wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-tooltip bottom>
                                            <v-btn icon medium slot="activator" flat @click="git(item)">
                                                <v-icon color="info" medium>search</v-icon>
                                            </v-btn>
                                            <span>{{ $t('Detail') }}</span>
                                        </v-tooltip>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-tooltip bottom>
                                            <v-btn icon medium slot="activator" flat
                                                   :loading="voucherLoadingRowKey === item.SiraNo"
                                                   :disabled="voucherLoadingRowKey !== null"
                                                   @click="voucherPdfAc(item)">
                                                <v-icon color="error" medium>picture_as_pdf</v-icon>
                                            </v-btn>
                                            <span>{{ $t('Voucher-PDF') }}</span>
                                        </v-tooltip>
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <v-tooltip bottom>
                                            <v-btn icon medium slot="activator" flat
                                                   :loading="cancelLoadingRowKey === item.SiraNo"
                                                   :disabled="cancelLoadingRowKey !== null"
                                                   @click="transferIptalOnay(item)">
                                                <v-icon color="warning" medium>block</v-icon>
                                            </v-btn>
                                            <span>{{ $t('Cancel') }}</span>
                                        </v-tooltip>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card>
                </v-hover>
            </v-flex>
        </v-container>

        <!-- sayfalama -->
        <template v-if="vmodelpagination">
            <div class="text-xs-center">
                <v-container>
                    <v-layout justify-center>
                        <v-flex xs8>
                            <v-pagination :disabled="paginationDisabled" color="info" v-model="sayfalama"
                                :length="pagenumber"></v-pagination>
                        </v-flex>
                    </v-layout>
                </v-container>
            </div>
        </template>

        <!-- Filtre Dialog -->
        <v-dialog v-model="filtreDialogStatus" scrollable persistent max-width="600px">
            <v-card flat color="grey lighten-4">
                <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 pa-2>
                            <!-- PNR -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <pnrbul v-model="Rapor.Filtreler.Prm.PPNR_No" :label="$t('PNR-No')" hide-details>
                                </pnrbul>
                            </v-flex>

                            <!-- Cari Kod -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <cariaracomp v-bind:etiket="$t('Currentcode_label')"
                                    v-bind:value="Rapor.Filtreler.Prm.PCariKod" v-model="Rapor.Filtreler.Prm.PCariKod"
                                    :Coper="false"></cariaracomp>
                            </v-flex>

                            <!-- Pickup Tarihi -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <tarihim :etiket="$t('Pickup') + ' ' + $t('Starting-Date')"
                                    v-model="Rapor.Filtreler.Prm.PDonem1Bas" :detaygizle="false"></tarihim>
                            </v-flex>

                            <!-- Pickup Tarihi Bitişi -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <tarihim :etiket="$t('Pickup') + ' ' + $t('Finishing-Date')"
                                    v-model="Rapor.Filtreler.Prm.PDonem1Bit" :detaygizle="false"></tarihim>
                            </v-flex>

                            <!-- Dropoff Tarihi Başlangıcı -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <tarihim :etiket="$t('Dropoff') + ' ' + $t('Starting-Date')"
                                    v-model="Rapor.Filtreler.Prm.PDonem2Bas" :detaygizle="false"></tarihim>
                            </v-flex>

                            <!-- Dropoff Tarihi Bitişi -->
                            <v-flex xs12 sm12 md12 pb-2>
                                <tarihim :etiket="$t('Dropoff') + ' ' + $t('Finishing-Date')"
                                    v-model="Rapor.Filtreler.Prm.PDonem2Bit" :detaygizle="false"></tarihim>
                            </v-flex>
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="filtreiptal()">
                        {{ $t("cancel_button") }}
                    </v-btn>
                    <v-btn color="blue darken-1" flat @click="filtrekayit()">
                        {{ $t('Apply-Filters') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import tool from "@/components/app/coper/tools";
import tarihim from "@/components/app/customcomp/tarihim";
import helpers from "@/components/app/customcomp/helpers.js";
import auth from "../../../../api/auth";
import pnrbul from "@/components/app/coper/component/pnrbul.vue";
import cariaracomp from "@/components/app/customcomp/cariaracomp.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import onaydialog from "@/components/app/customcomp/onaydialog.vue";
import loadingcomp from "@/components/app/customcomp/loadingcomp";

export default {
    data() {
        return {
            filtreDialogStatus: false,
            loadingmesaj: "",
            loadingvmodel: false,
            selectedCurrency: null,
            dovizItems: [],
            cardItems: [],
            totalCountText: null,
            paginationDisabled: false,
            vmodelpagination: false,
            sayfalama: 1,
            pagenumber: 1,
            text1: "",
            snackbar: false,
            filtrevarmi: false,
            tooltip: false,
            el: null,
            voucherLoadingRowKey: null,
            cancelLoadingRowKey: null,
            sayfayetki: {
                Screen: false,
                Update: false,
                Save: false,
                Delete: false,
                Status: false,
                Message: null,
                islem: 0
            },
            dictionary: {
                custom: {
                    tarihsec: {
                        required: () => this.$t('Please-choose-a-date')
                    },
                    tarihsec1: {
                        required: () => this.$t('Please-choose-a-date')
                    }
                }
            },
            veriItem: [
                { Text: "25", Value: 25 },
                { Text: "50", Value: 50 },
                { Text: "100", Value: 100 },
            ],
            siralamaItems: [
                { Text: this.$t('PNR-Number-Ascending'), Value: 0 },
                { Text: this.$t('PNR-Number-Descending'), Value: 1 },
                { Text: this.$t('Record-Date-Ascending'), Value: 2 },
                { Text: this.$t('Record-Date-Descending'), Value: 3 },
                { Text: this.$t('Check-In-Date-Ascending'), Value: 6 },
                { Text: this.$t('Check-In-Date-Descending'), Value: 7 },
            ],
            Rapor: {
                Filtreler: {
                    KayitTarihiBasla: null,
                    KayitTarihiBitis: null,
                    ParaBirimi: "TL",
                    SearchText: null,
                    Prm: {
                        PCariKod: null,
                        PPNR_No: null,
                        PSirketNo: null,
                        PCariSirket: null,
                        PPNR_ParaBirimi: null,
                        PKayitTarihBas: null,
                        PKayitTarihBit: null,
                        PDonem1Bas: null,
                        PDonem1Bit: null,
                        PDonem2Bas: null,
                        PDonem2Bit: null,
                        PFatTarihBas: null,
                        PFatTarihBit: null,
                        PKomFatTarihBas: null,
                        PKomFatTarihBit: null,
                        PSaticiTip: 2,
                        PSaticiKod: null,
                        PDosyaTip: null,
                        PDosya: null,
                        PAcente: null,
                        PPNRBir: null,
                        PCariHesapGrubu: null,
                        PCariTip: null,
                        PSaticiGrup: null,
                        PSaticiIc_Dis: null,
                        PTurOp: null,
                        PFaturali: null,
                        POpsiyon: null,
                        PAnaTip: null,
                        PCariAnaHesap: null,
                        PIptalRaporu: null,
                        PIptalDahil: true,
                        PRezGrupID: null,
                        PSatisGrubu: null,
                        PSatisGrupTip: null,
                        PSaticiOdemesiHesapla: null,
                        PMasrafMerkezi: null,
                        PAcenteDepartmanID: null,
                        PPozisyonNo: null,
                        PSatisFaturaNo: null,
                        PMusteriOdemelilerHaric: null,
                        PReferans: null,
                        PSatisTip1: null,
                        PSatisTip2: null,
                        PSatisTip3: null,
                        PSatisTip4: null,
                        PGelenFatTarihBas: null,
                        PGelenFatTarihBit: null,
                        PProfilSablonId: null,
                        PKomisyonFaturali: null,
                        PGelenFaturali: null,
                        PRezzKod: null
                    },
                },
                Paging: {
                    SiralamaTip: 0,
                    SayfaNo: 1,
                    VeriAdet: 25,
                },
            },
        };
    },
    components: {
        tarihim,
        pnrbul,
        cariaracomp,
        snackbarcomp,
        yetkidialog,
        onaydialog,
        loadingcomp,
    },
    watch: {
        sayfalama() {
            this.getList();
        },
    },
    filters: {
        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        moneyformat: function (m) {
            return helpers.moneyformat(m);
        },
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.prevRoute = from.path;
        });
    },
    mounted() {
        this.el = this.$refs.fab && this.$refs.fab.$el || null;
        this.$validator.localize("en", this.dictionary);
        this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    },
    methods: {
        git(item) {
            let url = "#/coper/rezervasyon/index/id?islem=get&PNR_No=" + item.PNR_No;
            window.open(url, "_blank");
        },
        voucherPdfAc(item) {
            this.voucherLoadingRowKey = item.SiraNo;
            var lang = this.$i18n.locale || 'tr';
            tool.downloadTransferVoucherPdf(this, item.PNR_No, lang, false)
                .then(() => {
                    this.voucherLoadingRowKey = null;
                })
                .catch((error) => {
                    this.text1 = this.$t('An-error-has-occurred-Please-try-again');
                    this.snackbar = true;
                    this.voucherLoadingRowKey = null;
                });
        },
        getList() {
            if (this.$refs.formFilters.validate()) {
                this.loadingvmodel = true;
                var _bastarih = new Date(this.Rapor.Filtreler.KayitTarihiBasla);
                var _bittarih = new Date(this.Rapor.Filtreler.KayitTarihiBitis);

                if (_bastarih <= _bittarih) {
                    var _credentials = JSON.parse(
                        window.localStorage.getItem("credentials")
                    );

                    this.Rapor.Paging.SiralamaTip = this.Rapor.Paging.SiralamaTip;
                    this.Rapor.Paging.SayfaNo = this.sayfalama;
                    this.Rapor.Paging.VeriAdet = this.Rapor.Paging.VeriAdet;

                    this.Rapor.Filtreler.Prm.PCariSirket = _credentials.SirketKodu;
                    this.Rapor.Filtreler.Prm.PSirketNo = _credentials.CoperSirketNo;

                    if (this.Rapor.Filtreler.Prm.PTurOp != null) {
                        this.Rapor.Filtreler.Prm.PTurOp =
                            this.Rapor.Filtreler.Prm.PTurOp.kod;
                    }

                    tool.http_post(this, "GunlukSatisListPagingOtel", this.Rapor).then(
                        (response) => {
                            if (response.body.Status == true) {
                                this.pagenumber = response.body.PageTotals.TotalPage;
                                if (response.body.PageTotals.TotalCount > 0) {
                                    this.totalCountText =
                                        this.$t("Total") +
                                        " " +
                                        response.body.PageTotals.TotalCount +
                                        " " +
                                        this.$t("Number-of-Records-Found");
                                } else {
                                    this.totalCountText = this.$t("No-Records-Found");
                                }

                                this.selectedCurrency = this.Rapor.Filtreler.ParaBirimi;
                                this.vmodelpagination = true;
                                this.cardItems = response.body.data;
                                this.loadingvmodel = false;
                            } else {
                                this.text1 = response.body.ErrorList[0];
                                this.snackbar = true;
                                this.loadingvmodel = false;
                            }
                            this.checkDriverUpdates();
                        },
                        (response) => {
                            this.HataYonetimi(response, this.Rapor, this.$t('Transfer-Reservations-Fetch-Error'));
                            this.loadingvmodel = false;
                        }
                    );
                } else {
                    this.text1 = this.$t("start-date-cannot-greater-than-end-date");
                    this.snackbar = true;
                    this.loadingvmodel = false;
                }
            }
        },

        HataYonetimi(response, request, baslik) {
            if (response.status === 500) {
                this.text1 = "Sunucu hatası - " + baslik;
                this.snackbar = true;
            } else {
                this.text1 = "Service Unavailable - " + baslik;
                this.snackbar = true;
            }
        },

        getListPageZero() {
            this.sayfalama = 1;
            this.getList();
        },

        filtreOpen() {
            this.filtreDialogStatus = true;
        },

        filtrekayit() {
            this.filtrevarmi = true;
            this.filtreDialogStatus = false;
            this.sayfalama = 1;
            this.getList();
        },

        filtreiptal() {
            this.filtrevarmi = false;
            this.filtreDialogStatus = false;
            this.Rapor.Filtreler.Prm.PPNR_No = null;
            this.Rapor.Filtreler.Prm.PCariKod = null;
            this.Rapor.Filtreler.Prm.PTurOp = null;
            this.Rapor.Filtreler.Prm.PSaticiTip = 2;
            this.Rapor.Filtreler.Prm.PSaticiKod = null;
            this.Rapor.Filtreler.Prm.PDosyaTip = null;
            this.Rapor.Filtreler.Prm.PDosya = null;
            this.Rapor.Filtreler.Prm.PAcente = null;
            this.Rapor.Filtreler.Prm.PPNRBir = null;
            this.Rapor.Filtreler.Prm.PCariHesapGrubu = null;
            this.Rapor.Filtreler.Prm.PCariTip = null;
            this.Rapor.Filtreler.Prm.PSaticiGrup = null;
            this.Rapor.Filtreler.Prm.PSaticiIc_Dis = null;
            this.Rapor.Filtreler.Prm.PFaturali = null;
            this.Rapor.Filtreler.Prm.POpsiyon = null;
            this.Rapor.Filtreler.Prm.PAnaTip = null;
            this.Rapor.Filtreler.Prm.PCariAnaHesap = null;
            this.Rapor.Filtreler.Prm.PIptalRaporu = null;
            this.Rapor.Filtreler.Prm.PRezGrupID = null;
            this.Rapor.Filtreler.Prm.PSatisGrubu = null;
            this.Rapor.Filtreler.Prm.PSatisGrupTip = null;
            this.Rapor.Filtreler.Prm.PSaticiOdemesiHesapla = null;
            this.Rapor.Filtreler.Prm.PMasrafMerkezi = null;
            this.Rapor.Filtreler.Prm.PAcenteDepartmanID = null;
            this.Rapor.Filtreler.Prm.PPozisyonNo = null;
            this.Rapor.Filtreler.Prm.PSatisFaturaNo = null;
            this.Rapor.Filtreler.Prm.PMusteriOdemelilerHaric = null;
            this.Rapor.Filtreler.Prm.PReferans = null;
            this.Rapor.Filtreler.Prm.PSatisTip1 = null;
            this.Rapor.Filtreler.Prm.PSatisTip2 = null;
            this.Rapor.Filtreler.Prm.PSatisTip3 = null;
            this.Rapor.Filtreler.Prm.PSatisTip4 = null;
            this.Rapor.Filtreler.Prm.PProfilSablonId = null;
            this.Rapor.Filtreler.Prm.PKomisyonFaturali = null;
            this.Rapor.Filtreler.Prm.PGelenFaturali = null;
            this.Rapor.Filtreler.Prm.PDonem1Bas = null;
            this.Rapor.Filtreler.Prm.PDonem1Bit = null;
            this.Rapor.Filtreler.Prm.PDonem2Bas = null;
            this.Rapor.Filtreler.Prm.PDonem2Bit = null;
        },

        transferIptalOnay(item) {
            this.$refs.onaydialog.open(this.$t('Transfer-Cancel-Confirm-Message'), 1).then(
                (sonuc) => {
                    if (sonuc == true) {
                        this.transferIptalEt(item);
                    }
                }
            );
        },

        transferIptalEt(item) {
            this.cancelLoadingRowKey = item.SiraNo;
            var bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));
            var params = {
                SessionHeader: {
                    SessionId: bookingParams.SessionId,
                    SessionToken: bookingParams.SessionToken,
                },
                BookingCode: item.RezzKod,
            };

            this.$http
                .post(auth.BOOKING_API_URL + "Transfer/Cancel", params, {
                    headers: {
                        Authorization:
                            "Basic " + window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
                    },
                })
                .then(
                    (response) => {
                        this.cancelLoadingRowKey = null;
                        if (response.body.HasError) {
                            this.text1 = (response.body.ServiceError && response.body.ServiceError.Message) || this.$t('An-error-has-occurred-Please-try-again');
                            this.snackbar = true;
                            return;
                        }
                        this.text1 = this.$t('Cancel-Reservation-Success');
                        this.snackbar = true;

                        tool.http_post(this, 'RezervasyonIptal', {
                            IptalTipi: 1,
                            IptalNo: item.PNR_No,
                            IptalNedeni: 'Transfer İptali',
                        }).then(
                            (response) => {
                                if (response.body.Status != true) {
                                    this.text1 = response.body.ErrorList[0];
                                    this.snackbar = true;
                                }
                                this.getList();
                            },
                            (response) => {
                                this.text1 = tool.HataMesajiCoz(response, this.$t.bind(this));
                                this.snackbar = true;
                                this.getList();
                            }
                        );
                    },
                    () => {
                        this.cancelLoadingRowKey = null;
                        this.text1 = this.$t('An-error-has-occurred-Please-try-again');
                        this.snackbar = true;
                    }
                );
        },

        checkDriverUpdates() {
            if (!this.cardItems || this.cardItems.length === 0) return;

            const bookingCodes = this.cardItems
                .filter(item => item.RezzKod)
                .map(item => item.RezzKod);

            if (bookingCodes.length === 0) return;

            var bookingParams = JSON.parse(window.localStorage.getItem("transferBookingParams"));
            if (!bookingParams) return;

            var params = {
                SessionHeader: {
                    SessionId: bookingParams.SessionId,
                    SessionToken: bookingParams.SessionToken,
                },
                BookingCodes: bookingCodes,
            };

            this.$http
                .post(auth.BOOKING_API_URL + "Report/IsReservationUpdated", params, {
                    headers: {
                        Authorization:
                            "Basic " + window.btoa(auth.HOTELRUNNERUSERNAME + ":" + auth.HOTELRUNNERUSERPASS),
                    },
                })
                .then(
                    (response) => {
                        if (response.body.HasError) {
                            console.warn("IsReservationUpdated error:", response.body);
                            return;
                        }

                        if (!response.body.UpdatedReservations || response.body.UpdatedReservations.length === 0) {
                            return;
                        }

                        this.applyDriverUpdates(response.body.UpdatedReservations);
                    },
                    (error) => {
                        console.warn("IsReservationUpdated request failed:", error);
                    }
                );
        },

        async applyDriverUpdates(updatedReservations) {
            const results = {
                success: 0,
                failed: 0,
                errors: []
            };

            for (const updatedRes of updatedReservations) {
                const item = this.cardItems.find(i => i.RezzKod === updatedRes.BookingCode);
                if (!item) continue;

                try {
                    await this.applyDriverUpdate(item.PNR_No, updatedRes);
                    results.success++;
                } catch (error) {
                    results.failed++;
                    results.errors.push(`PNR ${item.PNR_No}: ${error.message}`);
                }
            }

            if (results.success > 0 || results.failed > 0) {
                if (results.failed > 0) {
                    this.text1 = this.$t('Driver-Update-Partial', { success: results.success, failed: results.failed });
                } else {
                    this.text1 = this.$t('Driver-Update-Success', { count: results.success });
                }
                this.snackbar = true;
            }
        },

        async applyDriverUpdate(pnrNo, updatedReservation) {
            const loadResponse = await tool.http_post(this, "RezervasyonLoad", { PNR_No: pnrNo });
            if (loadResponse.body.Status !== true) {
                throw new Error(loadResponse.body.ErrorList ? loadResponse.body.ErrorList[0] : "Rezervasyon yüklenemedi");
            }

            const rezervasyon = loadResponse.body.data;
            if (!rezervasyon.kalemler || rezervasyon.kalemler.length === 0) {
                throw new Error("Kalem bulunamadı");
            }

            const kalemArac = rezervasyon.kalemler.find(k => k.kalemArac != null);
            if (!kalemArac) {
                throw new Error("Araç kalemi bulunamadı");
            }

            kalemArac.kalemArac.pinCode = updatedReservation.LicensePlate || null;

            const satici = await this.findOrCreateRehberSatici(updatedReservation.Driver, updatedReservation.DriverPhone);

            kalemArac.kalemArac.rehber = {
                YurtIci_YurtDisi: satici.IcDis || 0,
                CariKod: satici.CariKod || null,
                KDV: satici.KDV || 0,
                Yer: satici.Yer || null,
                Ulke: satici.Ulke || null,
                Sehir: satici.Sehir || null,
                SaticiKonumu: satici.SaticiKonumu || null,
                Web: satici.Web || null,
                Tel1: satici.Tel1 || null,
                Tel2: satici.Tel2 || null,
                Fax: satici.Fax || null,
                Teleks: satici.Teleks || null,
                EMail: satici.Email || null,
                GSM: updatedReservation.DriverPhone || satici.GSM || null,
                Adres: satici.Adres || null,
                id: satici.id,
                kod: satici.Kod,
                isim: satici.Isim,
                tip: 6,
                intField: null,
                tumSirketler: false,
                sayfaAdi: null,
            };

            const saveResponse = await tool.http_post(this, "RezervasyonKaydet", { Rezervasyon: rezervasyon });
            if (saveResponse.body.Status !== true) {
                throw new Error(saveResponse.body.ErrorList ? saveResponse.body.ErrorList[0] : "Rezervasyon kaydedilemedi");
            }
        },

        async findOrCreateRehberSatici(driverName, driverPhone) {
            const findResponse = await tool.http_post(this, "SaticiKodBul", {
                saticiKodu: driverName,
                saticiTipi: "6"
            });

            if (findResponse.body.Satici && findResponse.body.Satici != null) {
                return findResponse.body.Satici;
            }

            const insertResponse = await tool.http_post(this, "SaticiKayit", {
                SaticiTipi: 6,
                Kod: driverName,
                Isim: driverName,
                GSM: driverPhone || null,
                stRehber: { Diller: [], Cinsiyet: 0, Sinif: null, Donem1: null, Donem2: null }
            });

            if (insertResponse.body.Status !== true) {
                throw new Error(insertResponse.body.ErrorList ? insertResponse.body.ErrorList[0] : "Şoför satıcısı oluşturulamadı");
            }

            if (insertResponse.body.data && insertResponse.body.data.Satici) {
                return insertResponse.body.data.Satici;
            }

            const retryResponse = await tool.http_post(this, "SaticiKodBul", {
                saticiKodu: driverName,
                saticiTipi: "6"
            });

            if (retryResponse.body.Satici && retryResponse.body.Satici != null) {
                return retryResponse.body.Satici;
            }

            throw new Error("Şoför satıcısı bulunamadı");
        },
    }
};
</script>

<style scoped></style>